var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_94171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 29V14.5379C4.5 13.7262 4.99055 12.995 5.7416 12.6873L24.1355 5.14937C24.3762 5.05074 24.6338 5 24.8939 5H33",
    stroke: "#26BC96",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 27H30.5",
    stroke: "#98249A",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 47L6.5 47C5.39543 47 4.5 47.8954 4.5 49L4.5 53C4.5 54.1046 5.39543 55 6.5 55L30.5 55",
    stroke: "#0A70B8",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 31V43",
    stroke: "#FBBF00",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 31V43",
    stroke: "#A9D726",
    strokeWidth: 3.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2078_94171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0884 3H30.5V29H56.5C57.6046 29 58.5 28.1046 58.5 27V13.7719C58.5 12.9726 58.0241 12.25 57.2897 11.9344L36.8781 3.1625C36.6287 3.05529 36.36 3 36.0884 3Z",
    fill: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 29,
    width: 3.75,
    height: 16,
    fill: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 45H56.5C57.6046 45 58.5 45.8954 58.5 47V55C58.5 56.1046 57.6046 57 56.5 57H30.5V45Z",
    fill: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 29,
    width: 3.75,
    height: 16,
    fill: "#6D2FEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_94171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 54,
    fill: "white",
    transform: "translate(2.5 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2078_94171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 54,
    fill: "white",
    transform: "matrix(-1 0 0 1 58.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.ea8cb3e48c1703eeaf6268e3dad5d2af.svg";
export { ForwardRef as ReactComponent };